(function(window){

  const $ = require('jquery');
  const fancybox = require('../vendor/jquery.fancybox.js');

})(window);